// Face geometry of the approved JARVIS portrait (portrait-832, 832×1040 px), measured once with a face-landmark model.
// Local coordinates are rotated by the head roll so "up" follows her face. Re-measure if the source image changes.
export const PORTRAIT = {
  width: 832,
  height: 1040,
  src: { large: "/jarvis/portrait-832.webp", small: "/jarvis/portrait-560.webp", fallback: "/jarvis/portrait-832.jpg" },
  placeholder:
    "data:image/webp;base64,UklGRqAAAABXRUJQVlA4IJQAAAAQBACdASoQABQAPrVInkmnJCKhMAgA4BaJYwAAYegaENWjs6YDFMblAAD+RJsv3M2nCAYdMyU4YCunjdmpFW6Z3aSnWLNLmRzgl0sotAt1kgSk4J/28KdBFDWQnlU52GB+ruhaRwmQT5bGia1WDHVu1HHedk9TAoqvNSia76XOARCtdo29CkTYcPEiyAX+7B2oAAAA",
};

export const FACE = {
  roll: -0.2604,
  // [centerX, centerY, halfWidth], [upperLidApexX, upperLidApexY, lowerLidApexX, lowerLidApexY]
  eyeA: [325.6, 443.6, 48.2],
  eyeALids: [-9.6, -20.8, -2.8, 10.7],
  eyeB: [521.7, 390.7, 46.5],
  eyeBLids: [8.0, -20.5, 2.8, 10.9],
  // [centerX, centerY, halfWidth, chinDistance]; lower inner lip edge y = a·x² + b·x + c
  mouth: [482.3, 636.7, 93.7, 138.0],
  lowerLip: [-2.33e-3, -6.53e-2, 6.5],
  pivot: [530, 930],
};
